import { Badge } from "@babackapp/customer-ui/components/badge";
import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionDescription,
  OptionIcon,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { StarFilledIcon } from "@radix-ui/react-icons";
import { RefreshCcw } from "lucide-react";

export function DiscountOption() {
  return (
    <Label htmlFor="discount-type">
      <Option>
        <OptionIcon>
          <RefreshCcw />
        </OptionIcon>
        <OptionTitle>
          Bon de réduction
          <Badge variant="recomended">
            Recommendé <StarFilledIcon />
          </Badge>
        </OptionTitle>
        <OptionDescription>
          Recevez un bon de réduction à utiliser sur votre prochaine commande.
        </OptionDescription>
        <OptionAction>
          <RadioGroupItem value="discount-code" id="discount-type" />
        </OptionAction>
      </Option>
    </Label>
  );
}
